import request from '@/utils/request'

export const dashboardApi = {
  getStats() {
    return request({
      url: '/api/dashboard/stats',
      method: 'get'
    })
  },
  getOrderTrend(days = 7) {
    return request({
      url: '/api/dashboard/order-trend',
      method: 'get',
      params: { days }
    })
  },
  getServiceTypeDistribution() {
    return request({
      url: '/api/dashboard/service-type',
      method: 'get'
    })
  },
  getPlatformDistribution() {
    return request({
      url: '/api/dashboard/platform-distribution',
      method: 'get'
    })
  },
  getUserGrowthData() {
    return request({
      url: '/api/dashboard/user-growth',
      method: 'get'
    })
  }
}

export const userApi = {
  getList(params) {
    return request({
      url: '/api/user/list',
      method: 'get',
      params
    })
  },
  getDetail(id) {
    return request({
      url: `/api/user/${id}`,
      method: 'get'
    })
  },
  update(id, data) {
    return request({
      url: `/api/user/${id}`,
      method: 'put',
      data
    })
  },
  assignRoles(id, roleIds) {
    return request({
      url: `/api/user/${id}/roles`,
      method: 'put',
      data: { roleIds }
    })
  },
  updateAvatar(id, avatar) {
    return request({
      url: `/api/user/${id}/avatar`,
      method: 'put',
      data: { avatar }
    })
  },
  delete(id) {
    return request({
      url: `/api/user/${id}`,
      method: 'delete'
    })
  },
  create(data) {
    return request({
      url: '/api/user',
      method: 'post',
      data
    })
  },
  getFeedbackList(params) {
    return request({
      url: '/api/user/feedback/list',
      method: 'get',
      params
    })
  },
  replyFeedback(id, reply) {
    return request({
      url: `/api/user/feedback/${id}/reply`,
      method: 'put',
      data: { reply }
    })
  },
  getUserOrders(id, params) {
    return request({
      url: `/api/user/${id}/orders`,
      method: 'get',
      params
    })
  },
  getUserReviews(id, params) {
    return request({
      url: `/api/user/${id}/reviews`,
      method: 'get',
      params
    })
  }
}

export const petSitterApi = {
  getList(params) {
    return request({
      url: '/api/pet-sitter/list',
      method: 'get',
      params
    })
  },
  getDetail(id) {
    return request({
      url: `/api/pet-sitter/${id}`,
      method: 'get'
    })
  },
  audit(id, data) {
    return request({
      url: `/api/pet-sitter/${id}/audit`,
      method: 'put',
      data
    })
  },
  update(id, data) {
    return request({
      url: `/api/pet-sitter/${id}`,
      method: 'put',
      data
    })
  },
  setTop(id, isTop) {
    return request({
      url: `/api/pet-sitter/${id}/top`,
      method: 'put',
      data: { isTop }
    })
  },
  setRecommend(id, isRecommend) {
    return request({
      url: `/api/pet-sitter/${id}/recommend`,
      method: 'put',
      data: { isRecommend }
    })
  },
  setCanAcceptOrder(id, canAcceptOrder) {
    return request({
      url: `/api/pet-sitter/${id}/can-accept-order`,
      method: 'put',
      data: { canAcceptOrder }
    })
  }
}

export const financeApi = {
  getTransactionList(params) {
    return request({
      url: '/api/finance/transaction/list',
      method: 'get',
      params
    })
  },
  createRefund(data) {
    return request({
      url: '/api/finance/refund',
      method: 'post',
      data
    })
  },
  getRefundList(params) {
    return request({
      url: '/api/finance/refund/list',
      method: 'get',
      params
    })
  },
  approveRefund(id, handleRemark) {
    return request({
      url: `/api/finance/refund/${id}/approve`,
      method: 'put',
      data: { handleRemark }
    })
  },
  rejectRefund(id, handleRemark) {
    return request({
      url: `/api/finance/refund/${id}/reject`,
      method: 'put',
      data: { handleRemark }
    })
  },
  getWithdrawalList(params) {
    return request({
      url: '/api/finance/withdrawal/list',
      method: 'get',
      params
    })
  },
  approveWithdrawal(id, voucher) {
    return request({
      url: `/api/finance/withdrawal/${id}/approve`,
      method: 'put',
      data: { voucher }
    })
  },
  rejectWithdrawal(id, remark) {
    return request({
      url: `/api/finance/withdrawal/${id}/reject`,
      method: 'put',
      data: { remark }
    })
  },
  getSettlementStats(params) {
    return request({
      url: '/api/finance/settlement',
      method: 'get',
      params
    })
  }
}

export const systemApi = {
  getConfigList() {
    return request({
      url: '/api/system/config/list',
      method: 'get'
    })
  },
  updateConfig(data) {
    return request({
      url: '/api/system/config',
      method: 'put',
      data
    })
  },
  getRoleList(params) {
    return request({
      url: '/api/system/role/list',
      method: 'get',
      params
    })
  },
  getAllRoleList() {
    return request({
      url: '/api/system/role/all',
      method: 'get'
    })
  },
  getRoleDetail(id) {
    return request({
      url: `/api/system/role/${id}`,
      method: 'get'
    })
  },
  createRole(data) {
    return request({
      url: '/api/system/role',
      method: 'post',
      data
    })
  },
  updateRole(id, data) {
    return request({
      url: `/api/system/role/${id}`,
      method: 'put',
      data
    })
  },
  deleteRole(id) {
    return request({
      url: `/api/system/role/${id}`,
      method: 'delete'
    })
  },
  getRoleMenuIDs(id) {
    return request({
      url: `/api/system/role/${id}/menu-ids`,
      method: 'get'
    })
  },
  assignRoleMenus(id, menuIds) {
    return request({
      url: `/api/system/role/${id}/menus`,
      method: 'put',
      data: { menuIds }
    })
  },
  getAdminList(params) {
    return request({
      url: '/api/system/admin/list',
      method: 'get',
      params
    })
  },
  createAdmin(data) {
    return request({
      url: '/api/system/admin',
      method: 'post',
      data
    })
  },
  updateAdmin(id, data) {
    return request({
      url: `/api/system/admin/${id}`,
      method: 'put',
      data
    })
  },
  deleteAdmin(id) {
    return request({
      url: `/api/system/admin/${id}`,
      method: 'delete'
    })
  },
  getOperationLogList(params) {
    return request({
      url: '/api/system/log/list',
      method: 'get',
      params
    })
  }
}

export const menuApi = {
  getMenuList() {
    return request({
      url: '/api/menu/list',
      method: 'get'
    })
  },
  getMenuTree() {
    return request({
      url: '/api/menu/tree',
      method: 'get'
    })
  },
  getMenuByRoleID(roleID) {
    return request({
      url: `/api/menu/by-role/${roleID}`,
      method: 'get'
    })
  },
  createMenu(data) {
    return request({
      url: '/api/menu',
      method: 'post',
      data
    })
  },
  updateMenu(id, data) {
    return request({
      url: `/api/menu/${id}`,
      method: 'put',
      data
    })
  },
  deleteMenu(id) {
    return request({
      url: `/api/menu/${id}`,
      method: 'delete'
    })
  },
  getMenuDetail(id) {
    return request({
      url: `/api/menu/${id}`,
      method: 'get'
    })
  }
}

export const orderApi = {
  getList(params) {
    return request({
      url: '/api/order/list',
      method: 'get',
      params
    })
  },
  getDetail(id) {
    return request({
      url: `/api/order/${id}`,
      method: 'get'
    })
  },
  updateStatus(id, status) {
    return request({
      url: `/api/order/${id}/status`,
      method: 'put',
      data: { status }
    })
  },
  cancel(id, reason) {
    return request({
      url: `/api/order/${id}/cancel`,
      method: 'put',
      data: { reason }
    })
  }
}

export const fileApi = {
  uploadFile(file) {
    const formData = new FormData()
    formData.append('file', file, 'avatar.jpg')
    return request({
      url: '/api/file/upload',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  moveToPublic(tempFilePath, pathType) {
    return request({
      url: '/api/file/move-to-public',
      method: 'post',
      data: { tempFilePath, pathType }
    })
  }
}

export const authApi = {
  login(data) {
    return request({
      url: '/api/admin/login',
      method: 'post',
      data
    })
  },
  logout() {
    return request({
      url: '/api/admin/logout',
      method: 'post'
    })
  },
  getInfo() {
    return request({
      url: '/api/admin/info',
      method: 'get'
    })
  },
  selectRole(roleId) {
    return request({
      url: '/api/admin/select-role',
      method: 'post',
      data: { roleId }
    })
  },
  getCaptcha() {
    return request({
      url: '/api/admin/captcha',
      method: 'get'
    })
  }
}
